// extracted by mini-css-extract-plugin
module.exports = {"navbar":"NavBar_navbar__fRjHK","scrolled":"NavBar_scrolled__VctgU","show":"NavBar_show__6zQKv","hide":"NavBar_hide__TJeLo","bottomBorder":"NavBar_bottomBorder__fg_Kw"};